// @flow
import React from "react";
import type { Brand } from "@fdr/types/Product";
import styled from "styled-components";

const BaseSVG = (
  height: number,
  viewBox: string,
  width?: number
) => styled.svg.attrs({
  height,
  viewBox,
  width
})`
  display: inline-block;
  width: ${width ? `${width}px` : "auto"};
  height: ${height}px;
`;

export const logoMain = (height: number, className: string) => {
  const SVG = BaseSVG(height, "0 0 1022 182");

  return (
    <SVG data-qa-label="logo" className={className} width="140">
      <path
        d="M727.88 32.17h.13a1.6 1.6 0 0 1 1.42 1.41v75.13c0 13.65 7.98 21.72 20.42 21.72 12.31 0 20.36-8 20.52-21.32v-.4l.1-74.99v-.14a1.6 1.6 0 0 1 1.42-1.4l.14-.01h19.82a1.6 1.6 0 0 1 1.42 1.41v75.96c0 25.03-19.27 41.37-43.42 41.37-23.9 0-43.04-16.02-43.42-40.62V33.58a1.6 1.6 0 0 1 1.41-1.4l.14-.01h19.9zm-97.94 0c12.33 0 23.42 3.51 31.2 11.27 13.26 13.14 11.91 29.38 12.02 47.17 0 17.69 1.34 34.86-11.92 48.1-7.77 7.75-18.97 11.27-31.2 11.27h-41.17a1.6 1.6 0 0 1-1.42-1.55V68.03A1.6 1.6 0 0 1 589 66.6h20.04a1.6 1.6 0 0 1 1.42 1.55v61.13h17.1c7.87 0 13.26-2.48 17.2-7.24 4.35-5.27 4.98-13.65 4.98-31.54 0-17.9-.63-25.35-4.98-30.62-3.94-4.76-9.22-7.24-17.2-7.24H586.4c-.72 0-1.24-.52-1.45-1.24l-3.42-17.38v-.31c0-.83.73-1.55 1.56-1.55zm-305.61 0c.14 0 .23.02.4.1.78.3 1.2 1.05.98 1.83l-.05.14-6.42 17.37c-.2.58-.74.98-1.32 1.03h-53.71v28.97h41.97c.2 0 .31 0 .52.1.78.3 1.2 1.05.98 1.83l-.05.14-6.32 17.38c-.2.57-.74.97-1.32 1.02l-.13.01H264.2v46.23a1.6 1.6 0 0 1-1.42 1.55h-20.04c-.78 0-1.47-.55-1.54-1.4l-.01-.15V33.72c0-.78.65-1.47 1.42-1.55h81.71zm63.3 0c.59 0 1.16.35 1.4.9l.06.13 41.87 114.6c.1.21.1.32.1.52a1.6 1.6 0 0 1-1.42 1.55H408.88c-.57 0-1.15-.35-1.4-.9l-.05-.13-6.63-19.75h-41.97l-6.74 19.75c-.2.58-.74.98-1.32 1.03h-20.86c-.2 0-.3 0-.52-.1-.78-.29-1.2-1.04-.97-1.82l.04-.14 41.77-114.6c.28-.58.75-.98 1.39-1.03l.16-.01h15.86zm89.96 0c.47 0 .94.25 1.25.6l.1.12 46.33 71.37V33.58a1.6 1.6 0 0 1 1.41-1.4l.14-.01h20.04a1.6 1.6 0 0 1 1.4 1.41l.01.14v114.74a1.6 1.6 0 0 1-1.41 1.41h-18.28c-.46 0-.93-.24-1.24-.6l-.1-.12-46.33-71.57v70.88a1.6 1.6 0 0 1-1.42 1.41H459.32a1.6 1.6 0 0 1-1.41-1.4V33.57a1.6 1.6 0 0 1 1.41-1.4l.14-.01h18.13zm436.01 0c.14 0 .24.02.4.1.8.3 1.2 1.05.99 1.83l-.05.14-6.32 17.37c-.2.58-.74.98-1.32 1.03H853.6v27.63h43.25a1.6 1.6 0 0 1 1.41 1.41V99.33a1.6 1.6 0 0 1-1.41 1.4l-.14.02H853.6v28.65h53.58c.58 0 1.15.35 1.4.9l.05.13 6.32 17.38c.1.2.1.3.1.51a1.6 1.6 0 0 1-1.41 1.55H832a1.6 1.6 0 0 1-1.41-1.4V33.57a1.6 1.6 0 0 1 1.4-1.4l.15-.01h81.46zm30.36 0h20c.78 0 1.48.64 1.55 1.41V129.4h48.72c.58 0 1.16.36 1.32.9l.02.13 6.32 17.38c.1.2.1.3.1.51a1.6 1.6 0 0 1-1.4 1.55H943.81a1.6 1.6 0 0 1-1.4-1.4l-.01-.15V33.58a1.6 1.6 0 0 1 1.41-1.4l.14-.01h20zM380.28 66.92l-14.92 42.82h29.33l-14.41-42.82z"
        fill="#FFF"
      />
      <path
        d="M110.18 1.02l.23.01a181.32 181.32 0 0 1 40.52 8.9 186.84 186.84 0 0 1 27.88 12.3 7.3 7.3 0 0 1 3.94 6.63 193.78 193.78 0 0 1-3.32 30.2c-1.76 9.2-4.25 18.2-7.36 26.9a191.82 191.82 0 0 1-13.99 29.89 183.4 183.4 0 0 1-66.12 66.1c-.41.2-.83 0-1.03-.32a136.62 136.62 0 0 1-12.34-27.93 173.67 173.67 0 0 1-5.39-22.75.72.72 0 0 1 1.25-.62 142.98 142.98 0 0 0 16.79 14.79 151.74 151.74 0 0 0 54-77.37 150.74 150.74 0 0 0 5.17-24.82 152.62 152.62 0 0 0-59.17-11.9h-3c-.53 0-.84-.52-.63-1.03a114.58 114.58 0 0 1 19.8-27.93 3.98 3.98 0 0 1 3-1.04zM92.9 0c.63 0 .94.72.63 1.24a111.47 111.47 0 0 0-5.8 7.55 138.81 138.81 0 0 0-12.24 21.3c-.62 1.15-1.65 1.97-2.7 1.97a150.6 150.6 0 0 0-40.3 10.76 153 153 0 0 0 5.18 24.83c8.4-4.24 17.51-7.45 26.94-9.62.52-.1.93.41.83.93a171.13 171.13 0 0 0-4.77 30.3 3.61 3.61 0 0 1-2.28 3.21c-3 1.14-6 2.48-8.8 4.03 3.1 5.8 6.52 11.18 10.36 16.45.3.52.62 1.14.62 1.86a173.49 173.49 0 0 0 11.6 53.06c.32.62-.51 1.25-1.13.83a181.24 181.24 0 0 1-46.33-52.75 171.03 171.03 0 0 1-13.99-29.9c-3.1-8.68-5.6-17.68-7.36-26.89a170.56 170.56 0 0 1-3.31-30.2 7.28 7.28 0 0 1 3.83-6.72c8.91-4.86 18.24-9 27.88-12.31A183.25 183.25 0 0 1 91.34 0z"
        fill="#1493FF"
      />
    </SVG>
  );
};

export const LogoFDR = (
  height: number,
  className: string,
  fillColor: string = "#FFF"
) => {
  const SVG = BaseSVG(height, "0 0 140 40");

  return (
    <SVG data-qa-label="logo" className={className} width="140">
      <path
        fill={fillColor}
        d="M57.5969 27.5083C57.5969 25.562 56.3209 24.2294 54.0784 24.2294H49.8V34.584H51.4771V30.7188H53.0707L56.0307 34.584H58.087L54.9956 30.6353C56.6385 30.3244 57.5969 29.2136 57.5969 27.5083V27.5083ZM51.4771 29.241V25.8236H53.899C55.2585 25.8236 55.9074 26.5208 55.9074 27.5289C55.9074 28.537 55.2722 29.241 53.899 29.241H51.4771ZM19.7886 39.5203C19.8611 39.6956 19.8611 39.8189 19.7571 39.923C19.6435 40.0257 19.4682 40.0257 19.3039 39.923C7.34234 32.6391 0.123217 19.5684 0 5.85945C0 5.52936 0.113633 5.28145 0.391555 5.12668C6.74405 1.56693 13.8892 -0.145147 21.0659 0.00962493C21.3849 0.0205822 21.4985 0.298624 21.3753 0.55612C20.3855 2.60924 19.5599 4.70346 18.911 6.79767C18.8384 7.04558 18.6837 7.16885 18.4154 7.17981C14.5793 7.37567 10.8472 8.24267 7.42311 9.66574C7.67091 11.6161 8.09396 13.5241 8.6498 15.3608C11.3209 14.1226 14.1357 13.3693 16.8985 13.0392C17.1969 12.9981 17.3215 13.205 17.29 13.4419C16.9395 15.5676 16.7027 17.7235 16.6096 19.8999C16.5891 20.1478 16.4549 20.3121 16.177 20.3642C14.6409 20.6628 13.1458 21.138 11.4961 21.8914C12.9815 24.4704 14.775 26.8331 16.7547 28.8136C16.982 29.0506 17.1161 29.2985 17.1778 29.7012C17.6939 33.013 18.5906 36.355 19.7872 39.5216L19.7886 39.5203ZM40.2151 5.85945C40.122 18.837 33.6258 31.2571 22.6855 38.767C22.4788 38.9108 22.2118 38.8286 22.1187 38.5916C21.3247 36.4563 20.6757 34.2895 20.2116 32.1953C20.15 31.9173 20.2116 31.6995 20.4279 31.5351C27.0474 26.3154 31.6886 18.5275 32.8016 9.66574C29.4296 8.2728 25.7796 7.40717 21.9024 7.20035C21.6656 7.17981 21.4999 6.9634 21.5725 6.72645C22.3255 4.5391 23.1907 2.47639 24.171 0.55749C24.2846 0.330126 24.4804 0.238359 24.7487 0.268491C30.1525 0.876621 35.2659 2.57911 39.8236 5.12668C40.1015 5.28145 40.2261 5.52936 40.2151 5.85945V5.85945ZM58.6415 11.7148L57.7215 14.2555C57.6667 14.4116 57.5654 14.476 57.408 14.476H53.1296V19.1794C53.1296 19.3178 53.0379 19.4095 52.8996 19.4095H50.1395C50.0013 19.4095 49.9095 19.3178 49.9095 19.1794V5.83206C49.9095 5.69372 50.0013 5.60196 50.1395 5.60196H60.5815C60.7102 5.60196 60.8115 5.74029 60.7649 5.85945L59.8271 8.44537C59.7723 8.5933 59.671 8.65767 59.515 8.65767H53.1296V11.4559H58.4567C58.5854 11.4559 58.6867 11.5942 58.6401 11.7134L58.6415 11.7148ZM59.2754 19.4095H62.1641C62.3202 19.4095 62.4215 19.3356 62.468 19.189L63.3976 16.5017H68.7521L69.6817 19.189C69.7365 19.3369 69.8296 19.4095 69.9856 19.4095H72.9113C73.04 19.4095 73.1413 19.2712 73.0948 19.152L68.2551 5.81562C68.2004 5.6677 68.099 5.60333 67.943 5.60333H64.2451C64.089 5.60333 63.9877 5.6677 63.933 5.81562L59.0933 19.152C59.0467 19.2712 59.148 19.4095 59.2767 19.4095H59.2754ZM66.0742 8.72342L67.7212 13.4912H64.4272L66.0742 8.72342V8.72342ZM85.9723 19.4095H82.7988C82.6331 19.4095 82.5318 19.3547 82.4497 19.2068L77.61 10.9697V19.1794C77.61 19.3178 77.5183 19.4095 77.38 19.4095H74.6747C74.5364 19.4095 74.4447 19.3178 74.4447 19.1794V5.83206C74.4447 5.69372 74.5364 5.60196 74.6747 5.60196H77.8852C78.0508 5.60196 78.1521 5.65674 78.2343 5.80467L83.037 13.9774V5.83206C83.037 5.69372 83.1287 5.60196 83.267 5.60196H85.9723C86.1106 5.60196 86.2023 5.69372 86.2023 5.83206V19.178C86.2023 19.3164 86.1106 19.4082 85.9723 19.4082V19.4095ZM88.924 19.1794V12.7269C88.924 11.8613 89.2006 11.1902 89.6879 10.7026C90.1302 10.2602 90.8202 9.9657 91.4363 9.9657H91.9141C92.0523 9.9657 92.1441 10.0575 92.1441 10.1958V16.3538H94.058C96.2472 16.3538 97.9038 14.6965 97.9038 12.5064C97.9038 10.3163 96.2472 8.65904 94.058 8.65904H89.154C89.0157 8.65904 88.924 8.56727 88.924 8.42894V5.83343C88.924 5.69509 89.0157 5.60333 89.154 5.60333H94.058C98.0968 5.60333 101.124 8.56727 101.124 12.5064C101.124 16.4456 98.0968 19.4095 94.058 19.4095H89.154C89.0157 19.4095 88.924 19.3178 88.924 19.1794ZM114.849 5.83343V13.961C114.849 17.3482 112.457 19.667 108.98 19.667C105.502 19.667 103.11 17.3482 103.11 13.961V5.83206C103.11 5.69372 103.202 5.60196 103.34 5.60196H106.1C106.239 5.60196 106.33 5.69372 106.33 5.83206V13.9596C106.33 15.5238 107.426 16.6099 108.98 16.6099C110.533 16.6099 111.629 15.5238 111.629 13.9596V5.83206C111.629 5.69372 111.72 5.60196 111.859 5.60196H114.619C114.757 5.60196 114.849 5.69372 114.849 5.83206V5.83343ZM127.498 5.83343V8.42894C127.498 8.56727 127.406 8.65904 127.268 8.65904H120.8V10.9423H126.899C127.038 10.9423 127.129 11.034 127.129 11.1724V13.7309C127.129 13.8692 127.038 13.961 126.899 13.961H120.8V16.3538H127.268C127.406 16.3538 127.498 16.4456 127.498 16.5839V19.1794C127.498 19.3178 127.406 19.4095 127.268 19.4095H117.81C117.672 19.4095 117.58 19.3178 117.58 19.1794V5.83206C117.58 5.69372 117.672 5.60196 117.81 5.60196H127.268C127.406 5.60196 127.498 5.69372 127.498 5.83206V5.83343ZM140 16.5839V19.1794C140 19.3178 139.908 19.4095 139.77 19.4095H130.423C130.285 19.4095 130.193 19.3178 130.193 19.1794V5.83206C130.193 5.69372 130.285 5.60196 130.423 5.60196H133.183C133.322 5.60196 133.413 5.69372 133.413 5.83206V16.3524H139.77C139.908 16.3524 140 16.4442 140 16.5825V16.5839ZM71.2767 29.4081C71.2767 31.568 72.795 33.1637 74.9129 33.1637C76.3751 33.1637 77.5415 32.3761 78.0864 31.1681H79.8799C79.2241 33.3075 77.3197 34.758 74.9252 34.758C71.8476 34.758 69.5845 32.4665 69.5845 29.4081C69.5845 26.3496 71.8476 24.0513 74.9252 24.0513C77.3197 24.0513 79.2241 25.5004 79.8799 27.648H78.0864C77.5415 26.4332 76.3751 25.6456 74.9129 25.6456C72.795 25.6456 71.2767 27.2467 71.2767 29.4081V29.4081ZM63.0362 24.2307L59.0276 34.5854H60.8005L61.8492 31.8036H66.348L67.3967 34.5854H69.1697L65.1679 24.2307H63.0362ZM62.4571 30.223L64.1 25.888L65.7429 30.223H62.4585H62.4571ZM81.8801 24.2307H83.5504V34.5854H81.8801V24.2307ZM93.0586 24.2307H94.7015V34.5854H92.7287L87.6781 26.7852V34.5854H86.0353V24.2307H88.0081L93.0586 32.031V24.2307ZM101.562 29.0793H107.149V34.5799H105.701V32.509C105.213 33.8403 103.809 34.7566 101.96 34.7566C99.0332 34.7566 96.7715 32.509 96.7715 29.4176C96.7715 26.3263 99.0483 24.0499 102.108 24.0499C104.518 24.0499 106.41 25.4703 107.06 27.57H105.272C104.711 26.3866 103.558 25.647 102.094 25.647C99.9806 25.647 98.4582 27.2289 98.4582 29.4478C98.4582 31.5475 99.8478 33.2034 102.079 33.2034C103.809 33.2034 105.183 32.183 105.45 30.4969H101.562V29.0766V29.0793Z"
      />
    </SVG>
  );
};

export const LogoConnected = () => {
  const SVG = BaseSVG(240, "0 0 313 239", 340);

  return (
    <SVG data-qa-label="logo" width="278">
      <g
        id="Facebook-Create-Password"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Log-in-[M]-Reset-Password-success"
          transform="translate(-31.000000, -168.000000)"
        >
          <g id="Group" transform="translate(12.000000, 168.000000)">
            <g
              id="illustration-connected"
              transform="translate(19.000000, 0.000000)"
            >
              <g id="Illustration">
                <g id="Group-4">
                  <g id="Group-3" transform="translate(119.743278, 0.000000)">
                    <path
                      d="M56.322082,57.481982 L17.0341602,57.481982 C14.68695,57.481982 12.56195,58.4333769 11.0237526,59.9715743 C9.48555511,61.5097718 8.53416021,63.6347718 8.53416021,65.981982 L8.53416021,94.469112 L64.822082,94.469112 L64.822082,65.981982 C64.822082,63.6347718 63.8706871,61.5097718 62.3324896,59.9715743 C60.7942921,58.4333769 58.6692921,57.481982 56.322082,57.481982 Z"
                      id="Rectangle"
                      stroke="#B9C4CB"
                      strokeWidth="3"
                      fill="#CFD6DA"
                    />
                    <rect
                      id="Rectangle"
                      stroke="#B9C4CB"
                      strokeWidth="3"
                      fill="#1493FF"
                      transform="translate(37.180561, 34.988739) scale(1, -1) translate(-37.180561, -34.988739) "
                      x="30.656161"
                      y="12.4954955"
                      width="13.0488003"
                      height="44.9864865"
                    />
                    <rect
                      id="Rectangle"
                      fill="#0D7CD9"
                      transform="translate(40.697641, 34.988739) scale(1, -1) translate(-40.697641, -34.988739) "
                      x="39.1903212"
                      y="13.9954955"
                      width="3.01464009"
                      height="41.9864865"
                    />
                    <rect
                      id="Rectangle-Copy-8"
                      fill="#0D7CD9"
                      transform="translate(40.697641, 12.995817) scale(1, -1) translate(-40.697641, -12.995817) "
                      x="39.1903212"
                      y="10.9964607"
                      width="3.01464009"
                      height="3.998713"
                    />
                    <rect
                      id="Rectangle-Copy-9"
                      fill="#1493FF"
                      transform="translate(35.673241, 12.995817) scale(1, -1) translate(-35.673241, -12.995817) "
                      x="32.156161"
                      y="10.9964607"
                      width="7.03416021"
                      height="3.998713"
                    />
                    <rect
                      id="Rectangle"
                      fill="#F0F3F8"
                      x="36.1756811"
                      y="0"
                      width="6.02928018"
                      height="16.9945302"
                      rx="3"
                    />
                    <rect
                      id="Rectangle-Copy-11"
                      fill="#1493FF"
                      x="32.156161"
                      y="4.99839125"
                      width="4.01952012"
                      height="16.9945302"
                      rx="2"
                    />
                    <path
                      d="M22.1073607,105.965894 L28.1366408,105.965894 L28.1366408,123.959459 C28.1366408,125.064029 27.2412103,125.959459 26.1366408,125.959459 L24.1073607,125.959459 C23.0027912,125.959459 22.1073607,125.064029 22.1073607,123.959459 L22.1073607,105.965894 L22.1073607,105.965894 Z"
                      id="Rectangle"
                      fill="#818E95"
                    />
                    <rect
                      id="Rectangle-Copy-3"
                      fill="#B9C4CB"
                      x="21.1024806"
                      y="73.9761905"
                      width="4.01952012"
                      height="13.9954955"
                      rx="1.5"
                    />
                    <rect
                      id="Rectangle-Copy-4"
                      fill="#B9C4CB"
                      x="34.165921"
                      y="73.9761905"
                      width="4.01952012"
                      height="13.9954955"
                      rx="1.5"
                    />
                    <rect
                      id="Rectangle-Copy-5"
                      fill="#B9C4CB"
                      x="48.2342414"
                      y="73.9761905"
                      width="4.01952012"
                      height="13.9954955"
                      rx="1.5"
                    />
                    <path
                      d="M45.2196013,105.965894 L51.2488815,105.965894 L51.2488815,123.959459 C51.2488815,125.064029 50.353451,125.959459 49.2488815,125.959459 L47.2196013,125.959459 C46.1150318,125.959459 45.2196013,125.064029 45.2196013,123.959459 L45.2196013,105.965894 L45.2196013,105.965894 Z"
                      id="Rectangle-Copy-2"
                      fill="#818E95"
                    />
                    <rect
                      id="Rectangle"
                      fill="#445058"
                      x="22.1073607"
                      y="107.965251"
                      width="6.02928018"
                      height="4.99839125"
                    />
                    <rect
                      id="Rectangle-Copy-2"
                      fill="#445058"
                      x="45.2196013"
                      y="107.965251"
                      width="6.02928018"
                      height="4.99839125"
                    />
                    <path
                      d="M68.3562422,93.470399 L5,93.470399 C4.03350169,93.470399 3.15850169,93.8621498 2.52512627,94.4955252 C1.89175084,95.1289007 1.5,96.0039007 1.5,96.970399 L1.5,106.465251 L71.8562422,106.465251 L71.8562422,96.970399 C71.8562422,96.0039007 71.4644913,95.1289007 70.8311159,94.4955252 C70.1977405,93.8621498 69.3227405,93.470399 68.3562422,93.470399 Z"
                      id="Rectangle-Copy"
                      stroke="#B9C4CB"
                      strokeWidth="3"
                      fill="#CFD6DA"
                    />
                  </g>
                  <g
                    id="Group-3-Copy"
                    transform="translate(156.099520, 186.500000) rotate(180.000000) translate(-156.099520, -186.500000) translate(119.099520, 134.000000)"
                  >
                    <path
                      d="M56.322082,55.2057915 L17.0341602,55.2057915 C14.68695,55.2057915 12.56195,56.1571864 11.0237526,57.6953839 C9.48555511,59.2335813 8.53416021,61.3585813 8.53416021,63.7057915 L8.53416021,90.9933076 L64.822082,90.9933076 L64.822082,63.7057915 C64.822082,61.3585813 63.8706871,59.2335813 62.3324896,57.6953839 C60.7942921,56.1571864 58.6692921,55.2057915 56.322082,55.2057915 Z"
                      id="Rectangle"
                      stroke="#B9C4CB"
                      strokeWidth="3"
                      fill="#CFD6DA"
                    />
                    <rect
                      id="Rectangle"
                      stroke="#B9C4CB"
                      strokeWidth="3"
                      fill="#1F375B"
                      transform="translate(36.175681, 31.825654) scale(1, -1) translate(-36.175681, -31.825654) "
                      x="29.6512809"
                      y="9.44006864"
                      width="13.0488003"
                      height="44.7711712"
                    />
                    <rect
                      id="Rectangle"
                      fill="#122137"
                      transform="translate(32.658601, 31.825654) scale(1, -1) translate(-32.658601, -31.825654) "
                      x="31.1512809"
                      y="10.9400686"
                      width="3.01464009"
                      height="41.7711712"
                    />
                    <rect
                      id="Rectangle-Copy-6"
                      fill="#122137"
                      transform="translate(32.658601, 9.945517) scale(1, -1) translate(-32.658601, -9.945517) "
                      x="31.1512809"
                      y="7.95641356"
                      width="3.01464009"
                      height="3.97820678"
                    />
                    <rect
                      id="Rectangle-Copy-10"
                      fill="#122137"
                      transform="translate(37.683001, 50.722136) scale(1, -1) translate(-37.683001, -50.722136) "
                      x="34.165921"
                      y="48.733033"
                      width="7.03416021"
                      height="3.97820678"
                    />
                    <rect
                      id="Rectangle-Copy-7"
                      fill="#1F375B"
                      transform="translate(37.683001, 9.945517) scale(1, -1) translate(-37.683001, -9.945517) "
                      x="34.165921"
                      y="7.95641356"
                      width="7.03416021"
                      height="3.97820678"
                    />
                    <rect
                      id="Rectangle-Copy-3"
                      fill="#B9C4CB"
                      x="21.1024806"
                      y="70.6131703"
                      width="4.01952012"
                      height="13.9237237"
                      rx="1.5"
                    />
                    <rect
                      id="Rectangle-Copy-4"
                      fill="#B9C4CB"
                      x="35.170801"
                      y="70.6131703"
                      width="4.01952012"
                      height="13.9237237"
                      rx="1.5"
                    />
                    <rect
                      id="Rectangle"
                      fill="#1F375B"
                      x="35.170801"
                      y="0"
                      width="6.02928018"
                      height="16.9073788"
                      rx="3"
                    />
                    <rect
                      id="Rectangle-Copy-11"
                      fill="#F0F3F8"
                      x="31.1512809"
                      y="2.98365508"
                      width="4.01952012"
                      height="16.9073788"
                      rx="2"
                    />
                    <rect
                      id="Rectangle-Copy-5"
                      fill="#B9C4CB"
                      x="48.2342414"
                      y="70.6131703"
                      width="4.01952012"
                      height="13.9237237"
                      rx="1.5"
                    />
                    <rect
                      id="Rectangle"
                      fillOpacity="0.25"
                      fill="#AEB9C0"
                      style={{ mixBlendMode: "multiply" }}
                      x="7.03416021"
                      y="81.553239"
                      width="59.2879218"
                      height="6.96186186"
                    />
                    <path
                      d="M68.3562422,90.0151008 L5,90.0151008 C4.03350169,90.0151008 3.15850169,90.4068517 2.52512627,91.0402271 C1.89175084,91.6736025 1.5,92.5486025 1.5,93.5151008 L1.5,102.927928 L71.8562422,102.927928 L71.8562422,93.5151008 C71.8562422,92.5486025 71.4644913,91.6736025 70.8311159,91.0402271 C70.1977405,90.4068517 69.3227405,90.0151008 68.3562422,90.0151008 Z"
                      id="Rectangle-Copy"
                      stroke="#B9C4CB"
                      strokeWidth="3"
                      fill="#CFD6DA"
                    />
                  </g>
                  <g
                    id="graphic-accent"
                    transform="translate(0.000000, 87.202703)"
                  >
                    <path
                      d="M4.69872793,29.4414962 C5.19919912,29.4414962 5.60491118,29.8472082 5.60491118,30.3476794 L5.60487279,32.7984962 L8.01177617,32.7994548 C8.51756235,32.7994548 8.92758307,33.2094756 8.92758307,33.7152618 C8.92758307,34.2210479 8.51756235,34.6310687 8.01177617,34.6310687 L5.60487279,34.6304962 L5.60491118,37.0828441 C5.60491118,37.5833153 5.19919912,37.9890273 4.69872793,37.9890273 C4.19825675,37.9890273 3.79254469,37.5833153 3.79254469,37.0828441 L3.79187279,34.6304962 L1.3856797,34.6310687 C0.879893513,34.6310687 0.469872793,34.2210479 0.469872793,33.7152618 C0.469872793,33.2094756 0.879893513,32.7994548 1.3856797,32.7994548 L3.79187279,32.7984962 L3.79254469,30.3476794 C3.79254469,29.8472082 4.19825675,29.4414962 4.69872793,29.4414962 Z"
                      id="Combined-Shape"
                      fill="#41E878"
                    />
                    <path
                      d="M51.6860073,57.9332667 C52.1864785,57.9332667 52.5921905,58.3389787 52.5921905,58.8394499 L52.5921521,61.2902667 L54.9990555,61.2912253 C55.5048417,61.2912253 55.9148624,61.7012461 55.9148624,62.2070323 C55.9148624,62.7128184 55.5048417,63.1228392 54.9990555,63.1228392 L52.5921521,63.1222667 L52.5921905,65.5746146 C52.5921905,66.0750858 52.1864785,66.4807978 51.6860073,66.4807978 C51.1855361,66.4807978 50.779824,66.0750858 50.779824,65.5746146 L50.7791521,63.1222667 L48.372959,63.1228392 C47.8671728,63.1228392 47.4571521,62.7128184 47.4571521,62.2070323 C47.4571521,61.7012461 47.8671728,61.2912253 48.372959,61.2912253 L50.7791521,61.2902667 L50.779824,58.8394499 C50.779824,58.3389787 51.1855361,57.9332667 51.6860073,57.9332667 Z"
                      id="Combined-Shape"
                      fill="#41E878"
                    />
                    <path
                      d="M108.070742,0.949725683 C108.571214,0.949725683 108.976926,1.35543774 108.976926,1.85590893 L108.976887,4.30672568 L111.383791,4.30768435 C111.889577,4.30768435 112.299598,4.71770507 112.299598,5.22349126 C112.299598,5.72927745 111.889577,6.13929817 111.383791,6.13929817 L108.976887,6.13872568 L108.976926,8.59107359 C108.976926,9.09154477 108.571214,9.49725683 108.070742,9.49725683 C107.570271,9.49725683 107.164559,9.09154477 107.164559,8.59107359 L107.163887,6.13872568 L104.757694,6.13929817 C104.251908,6.13929817 103.841887,5.72927745 103.841887,5.22349126 C103.841887,4.71770507 104.251908,4.30768435 104.757694,4.30768435 L107.163887,4.30672568 L107.164559,1.85590893 C107.164559,1.35543774 107.570271,0.949725683 108.070742,0.949725683 Z"
                      id="Combined-Shape"
                      fill="#41E878"
                    />
                    <ellipse
                      id="Oval-2"
                      stroke="#1493FF"
                      strokeWidth="2"
                      cx="46.5174065"
                      cy="4.27376557"
                      rx="4.22885514"
                      ry="4.27376557"
                    />
                    <ellipse
                      id="Oval-2"
                      stroke="#1493FF"
                      cx="16.4455478"
                      cy="59.3578552"
                      rx="2.34936397"
                      ry="2.37431421"
                    />
                    <ellipse
                      id="Oval-2"
                      stroke="#1493FF"
                      strokeWidth="2"
                      cx="97.733541"
                      cy="43.6873814"
                      rx="5.63847352"
                      ry="5.6983541"
                    />
                  </g>
                  <g
                    id="graphic-accent"
                    transform="translate(200.650898, 87.202703)"
                  >
                    <path
                      d="M4.69872793,29.4414962 C5.19919912,29.4414962 5.60491118,29.8472082 5.60491118,30.3476794 L5.60487279,32.7984962 L8.01177617,32.7994548 C8.51756235,32.7994548 8.92758307,33.2094756 8.92758307,33.7152618 C8.92758307,34.2210479 8.51756235,34.6310687 8.01177617,34.6310687 L5.60487279,34.6304962 L5.60491118,37.0828441 C5.60491118,37.5833153 5.19919912,37.9890273 4.69872793,37.9890273 C4.19825675,37.9890273 3.79254469,37.5833153 3.79254469,37.0828441 L3.79187279,34.6304962 L1.3856797,34.6310687 C0.879893513,34.6310687 0.469872793,34.2210479 0.469872793,33.7152618 C0.469872793,33.2094756 0.879893513,32.7994548 1.3856797,32.7994548 L3.79187279,32.7984962 L3.79254469,30.3476794 C3.79254469,29.8472082 4.19825675,29.4414962 4.69872793,29.4414962 Z"
                      id="Combined-Shape"
                      fill="#41E878"
                    />
                    <path
                      d="M51.6860073,57.9332667 C52.1864785,57.9332667 52.5921905,58.3389787 52.5921905,58.8394499 L52.5921521,61.2902667 L54.9990555,61.2912253 C55.5048417,61.2912253 55.9148624,61.7012461 55.9148624,62.2070323 C55.9148624,62.7128184 55.5048417,63.1228392 54.9990555,63.1228392 L52.5921521,63.1222667 L52.5921905,65.5746146 C52.5921905,66.0750858 52.1864785,66.4807978 51.6860073,66.4807978 C51.1855361,66.4807978 50.779824,66.0750858 50.779824,65.5746146 L50.7791521,63.1222667 L48.372959,63.1228392 C47.8671728,63.1228392 47.4571521,62.7128184 47.4571521,62.2070323 C47.4571521,61.7012461 47.8671728,61.2912253 48.372959,61.2912253 L50.7791521,61.2902667 L50.779824,58.8394499 C50.779824,58.3389787 51.1855361,57.9332667 51.6860073,57.9332667 Z"
                      id="Combined-Shape"
                      fill="#41E878"
                    />
                    <path
                      d="M108.070742,0.949725683 C108.571214,0.949725683 108.976926,1.35543774 108.976926,1.85590893 L108.976887,4.30672568 L111.383791,4.30768435 C111.889577,4.30768435 112.299598,4.71770507 112.299598,5.22349126 C112.299598,5.72927745 111.889577,6.13929817 111.383791,6.13929817 L108.976887,6.13872568 L108.976926,8.59107359 C108.976926,9.09154477 108.571214,9.49725683 108.070742,9.49725683 C107.570271,9.49725683 107.164559,9.09154477 107.164559,8.59107359 L107.163887,6.13872568 L104.757694,6.13929817 C104.251908,6.13929817 103.841887,5.72927745 103.841887,5.22349126 C103.841887,4.71770507 104.251908,4.30768435 104.757694,4.30768435 L107.163887,4.30672568 L107.164559,1.85590893 C107.164559,1.35543774 107.570271,0.949725683 108.070742,0.949725683 Z"
                      id="Combined-Shape"
                      fill="#41E878"
                    />
                    <ellipse
                      id="Oval-2"
                      stroke="#1493FF"
                      strokeWidth="2"
                      cx="46.5174065"
                      cy="4.27376557"
                      rx="4.22885514"
                      ry="4.27376557"
                    />
                    <ellipse
                      id="Oval-2"
                      stroke="#1493FF"
                      cx="16.4455478"
                      cy="59.3578552"
                      rx="2.34936397"
                      ry="2.37431421"
                    />
                    <ellipse
                      id="Oval-2"
                      stroke="#1493FF"
                      strokeWidth="2"
                      cx="97.733541"
                      cy="43.6873814"
                      rx="5.63847352"
                      ry="5.6983541"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SVG>
  );
};

export const LogoEmail = () => {
  const SVG = BaseSVG(125, "0 0 278 125", 278);
  return (
    <SVG data-qa-label="logo" width="278">
      <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
        <g transform="translate(0 24)">
          <path
            d="M66.725 0c.56 0 1.013.453 1.013 1.012l-.001 2.725h2.694a1.02 1.02 0 110 2.04l-2.694-.001v2.726a1.013 1.013 0 01-2.024 0l-.001-2.726h-2.693a1.02 1.02 0 110-2.038l2.693-.001V1.013c0-.56.454-1.013 1.013-1.013zM4 51a1 1 0 011 1v2h2a1 1 0 010 2H4.999L5 58a1 1 0 01-2 0l-.001-2H1a1 1 0 010-2l2-.001V52a1 1 0 011-1z"
            fill="#41E878"
          />
          <ellipse
            stroke="#1493FF"
            strokeWidth="2"
            cx="45.725"
            cy="63.757"
            rx="4.725"
            ry="4.757"
          />
          <circle stroke="#1493FF" cx="20" cy="21" r="4" />
        </g>
        <g transform="translate(200 29)">
          <path
            d="M42 41.486c.56 0 1.013.453 1.013 1.012l-.001 2.725h2.694a1.02 1.02 0 110 2.04l-2.694-.001v2.725a1.013 1.013 0 01-2.025 0v-2.725h-2.693a1.02 1.02 0 110-2.039h2.693v-2.725c0-.559.454-1.012 1.013-1.012zM73 2.057c.56 0 1.013.453 1.013 1.013l-.001 2.724h2.694a1.02 1.02 0 110 2.04h-2.694v2.725a1.013 1.013 0 01-2.025 0V7.833h-2.693a1.02 1.02 0 110-2.038h2.693V3.07c0-.56.454-1.013 1.013-1.013z"
            fill="#41E878"
          />
          <ellipse
            stroke="#1493FF"
            cx="2.625"
            cy="43.071"
            rx="2.625"
            ry="2.643"
          />
          <ellipse
            stroke="#1493FF"
            strokeWidth="2"
            cx="27.975"
            cy="4.757"
            rx="4.725"
            ry="4.757"
          />
        </g>
        <path fill="#CFD6DA" d="M130.818 88.383L192.748 3l-16.593 100.644z" />
        <path
          fill="#B9C4CB"
          d="M130.818 88.383l-5.304 32.91-14.09-38.6L192.749 3z"
        />
        <path fill="#CFD6DA" d="M75 70.739L192.748 3l-81.323 79.693z" />
        <path
          fill="#818E95"
          opacity=".7"
          d="M125.514 121.293l24.663-26.4-19.359-6.51z"
        />
        <path
          d="M73.504 68.139l-.156.095c-2.076 1.357-1.691 4.565.717 5.355l35.04 11.5 13.59 37.233.07.172c.848 1.96 3.456 2.437 4.941.847l23.339-24.985 24.153 8.13a3 3 0 003.917-2.354L195.708 3.488c.411-2.497-2.263-4.35-4.456-3.088L73.504 68.139zM192.748 3l-16.593 100.644-25.983-8.747-24.658 26.396-14.09-38.6L75 70.739 192.748 3z"
          fill="#B9C4CB"
          fillRule="nonzero"
        />
      </g>
    </SVG>
  );
};

export const FDTVLogo = (
  height: number,
  width: number,
  fillColor: string = "#FFF"
) => {
  const SVG = BaseSVG(height, "0 0  47 16");

  return (
    <SVG data-qa-label="fdtv-logo" width={width} height={height}>
      <path
        fill={fillColor}
        d="M40.2568 4.01635H41.8972C41.8972 4.01635 42.0081 4.012 42.0532 4.14691L43.5719 9.67242L45.0906 4.14691C45.13 4.0116 45.2466 4.01596 45.2466 4.01596H46.8839C46.8839 4.01596 47.0349 4.0025 46.9925 4.14691L44.7311 11.903C44.7311 11.903 44.6886 12.0419 44.5743 12.0419H42.5515C42.4295 12.0419 42.3932 11.9026 42.3932 11.9026L40.1517 4.14573C40.11 3.99855 40.2568 4.01635 40.2568 4.01635Z"
      />
      <path
        fill={fillColor}
        d="M37.2571 12.0419H35.6777C35.5268 12.0419 35.5425 11.903 35.5425 11.903V5.79133H33.6103C33.4653 5.79133 33.4783 5.65167 33.4783 5.65167V4.14619C33.4783 4.01405 33.6103 4.01563 33.6103 4.01563H38.8696C38.9018 4.01563 39.0102 4.01325 39.0499 4.14619L39.4908 5.65167C39.5065 5.70429 39.5076 5.79727 39.3583 5.79133H37.3903V11.903C37.3895 11.903 37.4112 12.0419 37.2571 12.0419Z"
      />
      <path
        fill={fillColor}
        d="M28.9858 4.01367H26.1328C26.0525 4.01367 25.999 4.06717 25.999 4.14743V5.6563C25.999 5.73655 26.0525 5.79005 26.1328 5.79005H28.9858C30.26 5.79005 31.2233 6.75309 31.2233 8.02686C31.2233 9.30062 30.26 10.2637 28.9858 10.2637H27.8722V6.68364C27.8722 6.60339 27.8186 6.54989 27.7384 6.54989H27.46C27.1013 6.54989 26.6999 6.7212 26.4431 6.97791C26.1595 7.26136 25.999 7.65234 25.999 8.15496V11.9063C25.999 11.9865 26.0525 12.04 26.1328 12.04H28.9858C31.3355 12.04 33.0971 10.3172 33.0971 8.02686C33.0971 5.73655 31.336 4.01367 28.9858 4.01367Z"
      />
      <path
        fill={fillColor}
        d="M23.9717 7.41673H20.8722V5.79005H24.5872C24.6783 5.79005 24.7369 5.7525 24.7694 5.6671L25.3154 4.16338C25.3421 4.09393 25.2835 4.01367 25.2083 4.01367H19.1328C19.0525 4.01367 18.999 4.06717 18.999 4.14743V11.9068C18.999 11.9871 19.0525 12.0406 19.1328 12.0406H20.7384C20.8186 12.0406 20.8722 11.9871 20.8722 11.9068V9.17253H23.3614C23.4524 9.17253 23.5111 9.13497 23.5435 9.04392L24.0787 7.56694C24.1055 7.49749 24.0468 7.41673 23.9717 7.41673Z"
      />
      <path
        fill={fillColor}
        d="M6.63236 11.7421C6.60869 11.5867 6.55671 11.4915 6.46923 11.4C5.70451 10.636 5.01184 9.72441 4.43855 8.72896C5.07565 8.43829 5.65305 8.25515 6.2464 8.13992C6.35395 8.11985 6.40542 8.05606 6.41365 7.96089C6.44967 7.12132 6.54128 6.28946 6.67662 5.46943C6.68846 5.37786 6.6406 5.29812 6.52532 5.31407C5.45801 5.44165 4.37114 5.7318 3.33985 6.20972C3.12474 5.50133 2.96161 4.76516 2.86589 4.01252C4.18794 3.4631 5.62886 3.12871 7.11044 3.05308C7.21388 3.04897 7.27357 3.00112 7.30136 2.90595C7.55198 2.09776 7.87053 1.29008 8.25289 0.497834C8.30075 0.398546 8.257 0.291028 8.1335 0.286912C5.36229 0.227236 2.60292 0.887784 0.15026 2.26135C0.0427049 2.32103 -0.0010376 2.41671 -0.0010376 2.54378C0.0468217 7.83382 2.83398 12.8764 7.45266 15.6868C7.51647 15.7264 7.58389 15.7264 7.62763 15.6868C7.66725 15.6472 7.66725 15.5994 7.63947 15.5315C7.17786 14.3091 6.83152 13.0194 6.63236 11.7421Z"
      />
      <path
        fill={fillColor}
        d="M15.3754 2.26161C13.6154 1.27851 11.6408 0.621561 9.55403 0.386974C9.45059 0.375142 9.37494 0.410639 9.3312 0.498609C8.95296 1.2389 8.61846 2.03526 8.3277 2.87895C8.29991 2.97052 8.36372 3.05386 8.45532 3.06209C9.95234 3.14183 11.3619 3.47622 12.6639 4.0133C12.2336 7.4323 10.4423 10.4377 7.88616 12.4517C7.80279 12.5155 7.77861 12.5989 7.80279 12.7064C7.98188 13.5146 8.23301 14.35 8.53921 15.1742C8.57523 15.2658 8.67867 15.2977 8.75843 15.2421C12.9829 12.3442 15.4912 7.55217 15.5272 2.54507C15.5303 2.41698 15.4824 2.32129 15.3754 2.26161Z"
      />
    </SVG>
  );
};

type Props = {
  brand: Brand,
  height: number,
  className: string,
  fillColor?: string
};

const Logo = (props: Props) => {
  switch (props.brand) {
    default:
      return LogoFDR(props.height, props.className, props.fillColor);
  }
};

export default Logo;

Logo.defaultProps = {
  brand: "fdr",
  height: 18,
  className: ""
};
